<template>
    <div class="donut-chart">
        <design-2021-apprentice-pie-chart-component :series="pieChartData.series" :options="pieChartData.options">
        </design-2021-apprentice-pie-chart-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-module-show-tags-pie-chart-component",
    props: {
        dataIn: Array,
    },
    data(){
        return {
            values: [],
            labels: [],
            colors: [],
        }
    },
    computed: {
        pieChartData() {
            if(!this.dataIn.length){
                return {
                    series: [],
                    options: {}
                }
            }

            const values = [];
            const labels = [];
            const colors = [];

            this.dataIn.map((data)=>{
                values.push(data.duration);
                labels.push(data.name);
                colors.push(data.color);
            })

            return {
                series: values,

                options: {
                    labels: labels,
                    colors: colors,
                    plotOptions: {
                      pie: {
                          donut: {
                              labels: {
                                  show: true,
                                  name: {
                                      show: false,
                                      fontFamily: 'DM Sans, sans-serif',
                                      fontSize: '18px',
                                      fontWeight: 900,
                                      color: '#837c92'
                                  },
                                  value: {
                                      show: true,
                                      fontFamily: 'DM Sans, sans-serif',
                                      fontSize: '21px',
                                      fontWeight: 500,
                                      color: '#837c92',
                                      offsetY: 35,
                                      formatter: function (value){
                                          return value + 'h'
                                      }
                                  },
                                  total: {
                                      show: true,
                                      label: '',
                                      fontFamily: 'DM Sans, sans-serif',
                                      fontSize: '18px',
                                      fontWeight: 900,
                                      color: '#837c92',
                                      formatter: function (w) {
                                          return w.globals.seriesTotals.reduce((a, b) => {
                                              return a + b
                                          }, 0) + 'h'
                                      }
                                  }
                              }
                          }
                      }
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center',
                        fontSize: '14px',
                        fontFamily: 'DM Sans, sans-serif',
                        fontWeight: 400,
                        formatter: function(seriesName, opts) {
                            return [seriesName, " ", opts.w.globals.series[opts.seriesIndex] + "h"]
                        }
                    },
                    chartOptions: {
                        chart: {
                            type: 'donut',
                        },
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        }]
                    }
                }
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .donut-chart {
        position: relative;
        &:before {
            opacity: 1;
            position: relative;
            content: '\f017';
            font-size: 41px;
            font-family: "Font Awesome 5 Pro";
            font-weight: $font-weight-bolder;
            color: $warning;
            left: calc(50% - 20px);
            top: 105px;
        }

        &:after {
            content: '';
            width: 100px;
            height: 100px;
            display: block;
            border-radius: 100px;
            top: -176px;
            position: relative;
            left: calc(50% - 49px);
            box-shadow: inset 0 0.5rem 1rem rgb(0 0 0 / 15%);
        }
    }

</style>
